import React, { useEffect, useState } from "react";
import { Dropdown, ButtonGroup, Modal, Button, Form, Fade } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Topbar.css";

function Topbar({ sidebarCollapsed }) {
  const [staffData, setStaffData] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    code: "",
  });

  useEffect(() => {
    const storedStaff = localStorage.getItem("staffData");
    if (storedStaff) {
      const data = JSON.parse(storedStaff);
      setStaffData(data);
      setFormData({
        username: data.username || "",
        email: data.email || "",
        password: "",
        code: data.code || "",
      });
    }
  }, []);

  const handleCopyReferral = () => {
    if (staffData?.code) {
      navigator.clipboard.writeText(staffData.code);
      alert("Referral code copied: " + staffData.code);
    } else {
      alert("No referral code found.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("staffData");
    window.location.href = "/login";
  };


  const handleEditSave = async () => {
    if (!formData.username || !formData.email) {
      alert("Username and email cannot be empty.");
      return;
    }

    try {
      const response = await fetch("https://adminnvp.com//api/update_staff_profile.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        alert("Profile updated successfully!");
        localStorage.setItem("staffData", JSON.stringify({ ...staffData, ...formData }));
        setShowEditModal(false);
        window.location.reload();
      } else {
        alert("Failed to update profile: " + result.error);
      }
    } catch (err) {
      alert("Error updating profile: " + err.message);
    }
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center px-4 py-2 shadow-sm transition-all"
      style={{
        backgroundColor: "#ffffff",
        color: "#000",
        position: "fixed",
        top: 0,
        left: sidebarCollapsed ? "80px" : "250px",
        right: 0,
        height: "60px",
        zIndex: 1000,
        transition: "left 0.3s ease-in-out",
      }}
    >
      <div className="fw-bold fs-5">Admin Panel</div>

      {staffData && (
        <>
          <Dropdown
            as={ButtonGroup}
            align="end"
            show={showDropdown}
            onToggle={(isOpen) => setShowDropdown(isOpen)}
          >
            <Dropdown.Toggle
              id="dropdown-basic"
              variant="light"
              style={{
                border: "none",
                color: "#000",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "transparent",
                boxShadow: "none",
              }}
            >
              <div className="d-flex flex-column text-end">
                <span
                  style={{ fontSize: "12px", textTransform: "uppercase", color: "#777" }}
                >
                  {staffData.jabatan || "STAFF"}
                </span>
                <span style={{ fontWeight: "600" }}>
                  {staffData.username || "Unknown"}
                </span>
              </div>

            </Dropdown.Toggle>

            <Fade in={showDropdown}>
              <div>
                <Dropdown.Menu
                  className="shadow border-0 mt-2"
                  style={{
                    minWidth: "200px",
                    borderRadius: "10px",
                    animation: "fadeIn 0.2s ease-in-out",
                  }}
                >
                  <Dropdown.Header>
                    <div className="fw-bold">{staffData.username}</div>
                    <small className="text-muted">{staffData.email || ""}</small>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => setShowEditModal(true)}>
                    <i className="fas fa-user-edit me-2 text-primary"></i> Edit Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleCopyReferral}>
                    <i className="fas fa-link me-2 text-success"></i> Copy My Referral
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <i className="fas fa-sign-out-alt me-2"></i> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </div>
            </Fade>
          </Dropdown>

          {/* ✅ Modal Edit Profile */}
          <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Edit Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.username}
                    onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Leave blank to keep current"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Referral Code</Form.Label>
                  <Form.Control type="text" value={formData.code} readOnly />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleEditSave}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  );
}

export default Topbar;
